import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProjectDetailsService } from './project-details.service';
import { ProjectDetailsResolvedData } from './model/project-details-resolved-data.model';
import { ApprovalProjectStepBeans } from './model/approval-project-step-beans.model';

@Injectable({ providedIn: 'root' })
export class ProjectDetailsResolver  {
    constructor(private service: ProjectDetailsService) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<ProjectDetailsResolvedData> {
        const projectId = Number(route.pathFromRoot
            .map(r => r.params['projectId'])
            .find(id => !!id));

        const emptyApprovalSteps: ApprovalProjectStepBeans = { projectSteps: [], name: '' };

        return forkJoin({
            project: this.service.getProject(projectId),
            users: this.service.getProjectUsers(projectId).pipe(catchError(() => of([]))),
            sapCountries: this.service.getSapCountries(projectId).pipe(catchError(() => of([]))),
            approvalSteps: this.service.getApprovalSteps(projectId).pipe(catchError(() => of(emptyApprovalSteps)))
        }).pipe(
            catchError((err) => of({ project: null, users: [], sapCountries: [], approvalSteps: emptyApprovalSteps, loadError: err }))
        );
    }
}
